import React from "react";
import { Badge } from "@/shared/components/ui/Badge";

interface CategoryBadgeProps {
  category: string;
}

export const CategoryBadge: React.FC<CategoryBadgeProps> = ({ category }) => {
  return <Badge variant="info">{category}</Badge>;
};
